import React from 'react';

import { useLanguage } from '../i18n';
import ScooterParked from '../assets/ronda/scooter-parked.webp';
import Palm from '../assets/ronda/palm.webp';

const Closing = () => {
  const { closing } = useLanguage().t;

  return (
    <section id='start' className='pb-20 lg:pb-28'>
      <div className='container'>
        <div className='relative grid items-center gap-8 overflow-hidden rounded-panel bg-straw/30 px-6 pt-12 sm:px-10 lg:grid-cols-[1.1fr_1fr] lg:gap-6 lg:px-16 lg:pt-0'>
          <img
            src={Palm}
            alt=''
            aria-hidden='true'
            className='pointer-events-none absolute -top-4 right-[8%] w-[120px] sm:w-[150px] lg:right-[22%] lg:w-[170px]'
          />
          <div className='max-w-[520px] lg:py-20'>
            <h2 className='title'>{closing.title}</h2>
            <p className='lead mt-5'>{closing.text}</p>
            <div className='mt-10 flex flex-col gap-3 sm:flex-row sm:items-center'>
              <p className='inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-button bg-ink px-6 font-semibold text-canvas'>
                <span className='h-2 w-2 rounded-full bg-ronda-mint' aria-hidden='true' />
                {closing.badge}
              </p>
              <a href='#how-it-works' className='btn btn-outline'>
                {closing.link}
              </a>
            </div>
          </div>

          <div className='relative mx-auto w-full max-w-[460px] self-end' aria-hidden='true'>
            <img
              src={ScooterParked}
              alt=''
              loading='lazy'
              width='1000'
              height='910'
              className='relative h-auto w-full'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Closing;
